module.exports = __webpack_public_path__ + "img/69.99a01d1f.jpg";